<template>
  <b-row>
    <b-col cols="1">
      <span v-if="item['blockStatus'] === applicationStatuses.APPLICATION_BLOCK" style="color: #dc3545;"><i class="fa fa-lock fa-lg"></i></span>
      <span v-if="item['blockStatus'] === applicationStatuses.APPLICATION_UNBLOCK" style="color: #28a745;"><i class="fa fa-unlock fa-lg"></i></span>
    </b-col>
    <b-col cols="1">
      <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_SUCCESS" v-b-tooltip.hover :title="$t('views.application.list.connectionSuccess')" style="color: #28a745" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
      <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_FAILURE" v-b-tooltip.hover :title="$t('views.application.list.connectionFailure')" style="color: #dc3545;" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
    </b-col>
  </b-row>
</template>
<script>
import { applicationStatuses } from '@/utils/const/applicationStatuses'
export default {
  name: 'applicationStatus',
  props: {
    item: {},
    applicationData: null
  },
  data () {
    return {
      applicationStatuses: applicationStatuses
    }
  }
}
</script>
